import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { mergeRefs } from '@costar-ui/utils';
import React, { forwardRef, useMemo } from 'react';
import useTextEllipsisState from '../../hooks/use-text-ellipsis-state.esm.js';
import { useComponentTheme } from '../../theme/theme.context.esm.js';
import { useComponentVariant } from '../../theme/variant.context.esm.js';

var _excluded = ["textVariant"],
  _excluded2 = ["alignItems", "canShrink", "children", "className", "direction", "ellipsis", "fontFamily", "fullHeight", "fullWidth", "gap", "gapCol", "gapRow", "inline", "justify", "leading", "padding", "paddingX", "paddingY", "size", "testId", "title", "tracking", "variant", "weight"];
var Anchor = /*#__PURE__*/forwardRef(function Link(_ref, ref) {
  var textVariant = _ref.textVariant,
    props = _objectWithoutProperties(_ref, _excluded);
  var textVariantProps = useComponentVariant('Text', textVariant);
  var theme = useComponentTheme('Anchor');
  var _textVariantProps$pro = _objectSpread2(_objectSpread2({}, textVariantProps), props),
    alignItems = _textVariantProps$pro.alignItems,
    canShrink = _textVariantProps$pro.canShrink,
    children = _textVariantProps$pro.children,
    _textVariantProps$pro2 = _textVariantProps$pro.className,
    className = _textVariantProps$pro2 === void 0 ? '' : _textVariantProps$pro2,
    direction = _textVariantProps$pro.direction,
    ellipsis = _textVariantProps$pro.ellipsis,
    fontFamily = _textVariantProps$pro.fontFamily,
    fullHeight = _textVariantProps$pro.fullHeight,
    fullWidth = _textVariantProps$pro.fullWidth,
    gap = _textVariantProps$pro.gap,
    gapCol = _textVariantProps$pro.gapCol,
    gapRow = _textVariantProps$pro.gapRow,
    inline = _textVariantProps$pro.inline,
    justify = _textVariantProps$pro.justify,
    leading = _textVariantProps$pro.leading,
    padding = _textVariantProps$pro.padding,
    paddingX = _textVariantProps$pro.paddingX,
    paddingY = _textVariantProps$pro.paddingY,
    size = _textVariantProps$pro.size,
    testId = _textVariantProps$pro.testId,
    _title = _textVariantProps$pro.title,
    tracking = _textVariantProps$pro.tracking,
    _textVariantProps$pro3 = _textVariantProps$pro.variant,
    variant = _textVariantProps$pro3 === void 0 ? 'primary' : _textVariantProps$pro3,
    weight = _textVariantProps$pro.weight,
    rest = _objectWithoutProperties(_textVariantProps$pro, _excluded2);
  var _useTextEllipsisState = useTextEllipsisState(ellipsis, children, _title),
    localRef = _useTextEllipsisState.localRef,
    showTitle = _useTextEllipsisState.showTitle,
    title = _useTextEllipsisState.title,
    handleOnMouseOver = _useTextEllipsisState.handleOnMouseOver;
  var classes = useMemo(function () {
    return theme({
      alignItems: alignItems,
      canShrink: canShrink,
      className: className,
      direction: direction,
      ellipsis: ellipsis,
      fontFamily: fontFamily,
      fullHeight: fullHeight,
      fullWidth: fullWidth,
      gap: gap,
      gapCol: gapCol,
      gapRow: gapRow,
      inline: inline,
      justify: justify,
      leading: leading,
      padding: padding,
      paddingX: paddingX,
      paddingY: paddingY,
      size: size,
      tracking: tracking,
      variant: variant,
      weight: weight
    });
  }, [alignItems, canShrink, className, direction, ellipsis, fontFamily, fullHeight, fullWidth, gap, gapCol, gapRow, inline, justify, leading, padding, paddingX, paddingY, size, theme, tracking, variant, weight]);
  return /*#__PURE__*/React.createElement("a", _extends({
    className: "csg-tw-link ".concat(classes),
    ref: mergeRefs(ref, localRef),
    "data-testid": testId,
    title: showTitle ? title !== null && title !== void 0 ? title : '' : '',
    onMouseOver: handleOnMouseOver
  }, rest), children);
});
Anchor.displayName = 'Anchor';

export { Anchor as default };
//# sourceMappingURL=anchor.esm.js.map
